<template>

    <nav class="prvw">
        <div class="bg-header" :style="navStyle"></div>
        <div class="container n-mx">
            <div class="lft">
                <span class="logo">
                    <img v-if="logo" :src="logo" alt="brand logo" />
                    <img v-else src="/img/logo_name.svg" alt="brand logo" />
                </span>
                <ul class="lnks">
                    <li class="active">
                        <span class="ico"></span>
                        <span class="txt">Home</span>
                    </li>
                    <li v-if="Global.mockupConfig.content.vod">
                        <span class="ico"></span>
                        <span class="txt">Video On Demand</span>
                    </li>
                    <li v-if="Global.mockupConfig.content.live">
                        <span class="ico"></span>
                        <span class="txt">Live 24x7</span>
                    </li>
                    <li v-if="Global.mockupConfig.content.events">
                        <span class="ico"></span>
                        <span class="txt">Live Events</span>
                    </li>
                    <li v-if="Global.mockupConfig.content.replay">
                        <span class="ico"></span>
                        <span class="txt">Start Over & Replay</span>
                    </li>
                    <li v-if="Global.mockupConfig.content.podcast">
                        <span class="ico"></span>
                        <span class="txt">Podcast</span>
                    </li>
                    <li>
                        <span class="ico"></span>
                        <span class="txt">Favorites</span>
                    </li>
                </ul>
            </div>
            <div>
                <ul class="socials">
                    <li>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                            <rect opacity="0.01" width="30" height="30" fill="#D8D8D8"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12V12C22 17.523 17.523 22 12 22V22C6.47703 22 2 17.523 2 12V12C2 6.47703 6.47703 2 12 2V2C17.523 2 22 6.47703 22 12Z" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.5 19.5L23.5 23.5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M23 23L26.3284 26.3284" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </li>
                    <li>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                            <rect opacity="0.01" width="30" height="30" fill="#D8D8D8"/>
                            <circle cx="15.5" cy="9.5" r="8.25" fill="white" stroke="white" stroke-width="2.5"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 19.3502C3 18.1499 4.27981 16.9603 5 16C5.93746 14.7501 6 14 6 13C6 12.222 12.0531 14.4706 14.7405 15.5072C15.5035 15.8015 16 16.5363 16 17.3541V23H5C3.89543 23 3 22.1046 3 21V19.3502Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M28 19.3502C28 18.1499 26.7202 16.9603 26 16C25.0625 14.7501 25 14 25 13C25 12.222 18.9469 14.4706 16.2595 15.5072C15.4965 15.8015 15 16.5363 15 17.3541V23H26C27.1046 23 28 22.1046 28 21V19.3502Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.75 25C11.75 27.0711 13.4289 28.75 15.5 28.75C17.5711 28.75 19.25 27.0711 19.25 25" fill="white"/>
                            <rect x="6" y="10" width="19" height="10" fill="white"/>
                        </svg>
                    </li>
                    <!-- <li></li> -->
                </ul>
            </div>
        </div>
    </nav>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'PreviewHeadbar',

        props: {
            scroll: Number,
            logo: String
        },

        data() {
            return {
                Global
            }
        },


        computed: {
            navStyle() {
                if (this.scroll >= 60)
                    return { transform: 'scaleY(1)' }
                else
                    return { transform: 'scaleY(0)' }
            }
        }

    }

</script>